// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {buildCurrency} from '../../services/build-number';

const Currency = props =>
    <span {...props}>
        {buildCurrency(props.children)}
    </span>;

Currency.displayName = 'Currency';
Currency.propTypes = {
    children: PropTypes.number
};

export default Currency;



// WEBPACK FOOTER //
// ./src/shared/components/currency/index.js